import { connect } from 'react-redux'

import { fetchAgencyStatus } from 'app/bond_cover/agency/agency_actions'
import {
  addRentalReputationBackUrl,
  clearRentalBackUrl,
  deleteLastRentalBackUrl,
  setBackUrl,
} from 'app/shared_components/actions'
import {
  aboutMeInput,
  acceptApplication,
  acceptJointApplicationAsSecondary,
  addCurrentNewTenant,
  adultInput,
  childrenInput,
  clearCurrentNewTenant,
  createOffPlatformApplication,
  deleteDraftApplication,
  editOffPlatformApplication,
  fetchApplicantSummary,
  fetchApplication,
  fetchApplicationForApplicant,
  fetchApplyAnywhereListing,
  fetchCompleteness,
  fetchProperty,
  groupInput,
  heartClicked,
  householdYearlyInput,
  newTenant,
  onAdderChange,
  peopleInput,
  petsInput,
  ping,
  removeOccupant,
  removeTenant,
  requestsInput,
  saveDraftApplication,
  startNewApplication,
  submitApplication,
  submitQuickApplication,
} from 'app/sm/apply/apply_actions'
import ApplyContainer from 'app/sm/apply/apply_container'
import { deleteManagerAttachment } from 'app/sm/documents/actions'
import { fetchOfferedApplication } from 'app/sm/oa_tenant/oa_tenant_actions'
import { fetchTeamSettingInformation } from 'app/sm/rental_reputation/actions'
import {
  acceptSecondaryWithdraw,
  acceptWithdraw,
} from 'app/sm/withdraw_confirmation/withdraw_confirmation_actions'

const mapStateToProps = ({ apply, session, WithdrawConfirmation }) => ({
  property: apply.property,
  propertyId: apply.propertyId,
  adders: apply.adders,
  applicant: apply.applicant,
  application: apply.application,
  summary: apply.summary,
  snugRank: apply.snugRank,
  otherOffers: apply.otherOffers,
  completeness: apply.completeness,
  error: apply.error,
  currentUser: session.currentUser,
  takeHoldingDeposit: apply.takeHoldingDeposit,
  isJoint: apply.application.isJoint,
  applyAnywhereListing: apply.applyAnywhereListing,
  solicitedAbovePrice: apply.solicitedAbovePrice,
  isQLDForm22: apply.isQLDForm22,
  teams: session.teams,
})

const mapDispatchToProps = (dispatch) => ({
  fetchCompleteness: () => dispatch(fetchCompleteness()),
  ping: () => dispatch(ping()),
  fetchProperty: (propertyId) => dispatch(fetchProperty(propertyId)),
  fetchApplication: (applicationId) =>
    dispatch(fetchApplication(applicationId)),
  fetchApplicationForApplicant: (applicationId, success) =>
    dispatch(fetchApplicationForApplicant(applicationId, success)),
  fetchApplicantSummary: () => dispatch(fetchApplicantSummary()),
  onAdderChange: (adderType, operation, payload, isApplyAnywhere) =>
    dispatch(onAdderChange(adderType, operation, payload, isApplyAnywhere)),
  groupInput: (input) => dispatch(groupInput(input)),
  petsInput: (input) => dispatch(petsInput(input)),
  peopleInput: (input) => dispatch(peopleInput(input)),
  adultInput: (input) => dispatch(adultInput(input)),
  childrenInput: (input) => dispatch(childrenInput(input)),
  requestsInput: (input) => dispatch(requestsInput(input)),
  aboutMeInput: (input) => dispatch(aboutMeInput(input)),
  householdYearlyInput: (input) => dispatch(householdYearlyInput(input)),

  submitApplication: (
    isOffer,
    applicants,
    applicantSummary,
    success,
    fail,
    children,
    applicationOption,
    allVehicles,
  ) =>
    dispatch(
      submitApplication(
        isOffer,
        applicants,
        applicantSummary,
        success,
        fail,
        children,
        applicationOption,
        allVehicles,
      ),
    ),
  submitQuickApplication: (applicants, applicantSummary) =>
    dispatch(submitQuickApplication(applicants, applicantSummary)),
  heartClicked: (propertyId, isFavorite) =>
    dispatch(heartClicked(propertyId, isFavorite)),
  fetchOfferedApplication: (id) => dispatch(fetchOfferedApplication(id)),
  acceptWithdraw: (id, success, fail) =>
    dispatch(acceptWithdraw(id, success, fail)),
  acceptSecondaryWithdraw: (applicationId, applicantId, success, fail) =>
    dispatch(
      acceptSecondaryWithdraw(applicationId, applicantId, success, fail),
    ),
  addRentalReputationBackUrl: (url) =>
    dispatch(addRentalReputationBackUrl(url)),
  saveDraftApplication: (
    applicants,
    applicantSummary,
    isApplyAnywhere,
    applyAnywhereGUID,
    children,
    applicationOption,
    allVehicles,
    config,
    referrerPayload,
  ) =>
    dispatch(
      saveDraftApplication(
        applicants,
        applicantSummary,
        isApplyAnywhere,
        applyAnywhereGUID,
        children,
        applicationOption,
        allVehicles,
        config,
        referrerPayload,
      ),
    ),
  acceptApplication: (offerId, applicationId, propertyId) =>
    dispatch(acceptApplication(offerId, applicationId, propertyId)),
  newTenant: (tenant) => dispatch(newTenant(tenant)),
  removeTenant: (applicantId, success) =>
    dispatch(removeTenant(applicantId, success)),
  acceptJointApplicationAsSecondary: (
    applicationId,
    applicantId,
    applicantSummary,
    apply,
  ) =>
    dispatch(
      acceptJointApplicationAsSecondary(
        applicationId,
        applicantId,
        applicantSummary,
        apply,
      ),
    ),
  deleteDraftApplication: (applicationId, success, fail) =>
    dispatch(deleteDraftApplication(applicationId, success, fail)),
  addCurrentNewTenant: (currentTenant) =>
    dispatch(addCurrentNewTenant(currentTenant)),
  clearCurrentNewTenant: () => dispatch(clearCurrentNewTenant()),
  clearRentalBackUrl: () => dispatch(clearRentalBackUrl()),
  fetchApplyAnywhereListing: (applyAnywhereListingGUID) =>
    dispatch(fetchApplyAnywhereListing(applyAnywhereListingGUID)),
  setBackUrl: (url) => dispatch(setBackUrl(url)),
  removeOccupant: (teamId, occupantId) =>
    dispatch(removeOccupant(teamId, occupantId)),
  createOffPlatformApplication: (application) =>
    dispatch(createOffPlatformApplication(application)),
  updateOffPlatformApplication: (application, applicationId) =>
    dispatch(editOffPlatformApplication(application, applicationId)),
  deleteManagerAttachment: (documentId) =>
    dispatch(deleteManagerAttachment(documentId)),
  fetchTeamSettingInformation: (teamId, queryString) =>
    dispatch(fetchTeamSettingInformation(teamId, queryString)),
  startNewApplication: () => dispatch(startNewApplication()),
  deleteLastRentalBackUrl: () => dispatch(deleteLastRentalBackUrl()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ApplyContainer)
